import { jsx as _jsx } from "react/jsx-runtime";
import { useAppSelector } from 'utils/redux/useAppSelector';
import { Login } from './components/login';
import { Upgrade } from './components/upgrade';
export function Knowledge() {
    const { elevio_workspace_id } = useAppSelector((state) => state.settings.organization.organization);
    return elevio_workspace_id ? _jsx(Login, {}) : _jsx(Upgrade, {});
}
